import React from 'react';
import { BrandPill } from 'molecules';
import { ROUTES } from 'constants/routes';

type HomeHeroSectionProps = {
  heroLogoSrc: string;
  aquaristLogoSrc: string;
  idleCafeLogoSrc: string;
};

const HomeHeroSection: React.FC<HomeHeroSectionProps> = ({
  heroLogoSrc,
  aquaristLogoSrc,
  idleCafeLogoSrc,
}) => {
  return (
    <>
      <section className="hero">
        <img
          src={heroLogoSrc}
          alt="Midnight Swim"
          className="hero-logo-with-text"
        />
      </section>

      <section className="content-section">
        <div className="pill-grid">
          <BrandPill
            logoSrc={aquaristLogoSrc}
            label="Aquarist"
            brand="aquarist"
            to={ROUTES.aquarist}
          />
          <BrandPill
            logoSrc={idleCafeLogoSrc}
            label="Idle Café"
            brand="idlecafe"
            to={ROUTES.idleCafe}
          />
        </div>
      </section>
    </>
  );
};

export default HomeHeroSection;
